// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__vfwPT","disabled":"FileBtn_disabled__1x8xx","warn":"FileBtn_warn__2HFXZ","fade":"FileBtn_fade__3mj-Z"};